import Base from '../../../../../../shared/Api';
import { IOrder, IOrderSearchResultItem } from './Types';

class Api {
    static getFirstPlanOrder(firstPlanOrderId: number): Promise<IOrder> {
        return new Base().get(`/views/planorder/swap/${firstPlanOrderId}/first`);
    }

    static search(search: string): Promise<{ orders: IOrderSearchResultItem[] }> {
        let searchTerm = encodeURIComponent(search);
        return new Base().get(`/views/planorder/swap/search?search=${searchTerm}`);
    }

    static getSecondPlanOrder(
        firstPlanOrderId: number,
        secondPlanOrderId: string
    ): Promise<IOrder> {
        return new Base().get(
            `/views/planorder/swap/${firstPlanOrderId}/${secondPlanOrderId}/second`
        );
    }

    static verify(firstPlanOrderId: number, secondPlanOrderId: number): Promise<number> {
        return new Base().get(
            `/views/planorder/swap/${firstPlanOrderId}/${secondPlanOrderId}/verify`
        );
    }

    static do(firstPlanOrderId: number, secondPlanOrderId: number): Promise<any> {
        return new Base().put(`/views/planorder/swap/${firstPlanOrderId}/${secondPlanOrderId}/do`);
    }
}

export default Api;
